


import { NgModule } from '@angular/core';
import {

  MatCardModule,
  MatInputModule,
  MatStepperModule,
  MatTableModule,
  MatPaginatorModule,
  MatDialogModule,
  MatExpansionModule,
  MatSidenavModule,
  MatToolbarModule,
  MatIconModule,
  MatListModule,
  MatButtonModule,
  MatMenuModule,
  MatDatepickerModule,
  MatTabsModule,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  DateAdapter,
  MatCheckboxModule,
  MatTooltipModule,

  MatSlideToggleModule,
  MatFormFieldModule


 } from '@angular/material';
import { MatMomentDateModule, MomentDateAdapter  } from '@angular/material-moment-adapter';
import { MY_DATE_FORMATS } from './config/my-date-format';


@NgModule ({
  imports: [

    MatCardModule,
    MatInputModule,
    MatStepperModule,
    MatTableModule,
    MatPaginatorModule,
    MatDialogModule,
    MatExpansionModule,
    MatSidenavModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatButtonModule,
    MatMenuModule,
    MatDatepickerModule,
    MatMomentDateModule,
    MatTabsModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatFormFieldModule
    
    



    




  ],

  providers: [
    {provide: DateAdapter, useClass: MomentDateAdapter},
    {provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS},
    {provide: MAT_DATE_LOCALE, useValue: 'en-US'}
  ],
  
  exports: [

    MatCardModule,
    MatInputModule,
    MatStepperModule,
    MatTableModule,
    MatPaginatorModule,
    MatExpansionModule,
    MatSidenavModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatButtonModule,
    MatMenuModule,
    MatDatepickerModule,
    MatMomentDateModule,
    MatTabsModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatDialogModule,
    MatFormFieldModule
   




  ]
  
})
export class MaterialModule {}

